import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DealConfig, DealConfigStore } from './dealConfig.types';

export const initialState: Partial<DealConfigStore> = {
  isDealConfigFetched: false,
  maxAllowedLinesPerDeal: 1,
  enableLineLevelTrading: false,
  dspsThatSupportSynchronisation: [],
  dspsSupportingCreativeSubmissionInBidStream: [],
  enableOpenMarketplace: [],
  billingRules: [],
};

const dealConfigSlice = createSlice({
  name: 'dealConfig',
  initialState,
  reducers: {
    updateDealConfig: (store: DealConfigStore, action: PayloadAction<Partial<DealConfig>>) => {
      return {
        ...store,
        ...action.payload,
        isDealConfigFetched: true,
      };
    },
    resetDealConfig: () => {
      return initialState;
    },
  },
});

export const { updateDealConfig, resetDealConfig } = dealConfigSlice.actions;
export default dealConfigSlice.reducer;
